import { render, staticRenderFns } from "./catNotices.vue?vue&type=template&id=1af9f84a&scoped=true"
import script from "./catNotices.vue?vue&type=script&lang=js"
export * from "./catNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9f84a",
  null
  
)

export default component.exports